import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../config';
import BrandMark from './BrandMark';
import SiteFooter from './SiteFooter';
import './Login.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/auth/forgot-password`, { email });
      setMessage(response.data.message || 'Проверьте почту');
    } catch (err) {
      setError(err.response?.data?.error || 'Не удалось отправить письмо');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-brand">
          <BrandMark size="md" />
        </div>
        <h1 className="login-title">Сброс пароля</h1>
        <p className="login-subtitle">
          Укажите email аккаунта — пришлём ссылку для нового пароля.
        </p>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="field"
              autoComplete="email"
            />
          </div>

          {error && <div className="alert alert-error">{error}</div>}
          {message && <div className="alert alert-success">{message}</div>}

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Отправка...' : 'Отправить ссылку'}
          </button>
        </form>

        <div className="toggle-mode">
          <Link to="/login" className="toggle-button">
            Назад ко входу
          </Link>
        </div>

        <SiteFooter className="site-footer--auth" />
      </div>
    </div>
  );
}

export default ForgotPassword;
